import { render, staticRenderFns } from "./AssessorUpdate.vue?vue&type=template&id=9b2e41c2&"
import script from "./AssessorUpdate.vue?vue&type=script&lang=js&"
export * from "./AssessorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports